<template lang="pug">
.avatar-child
  .avatar
    child-icon
    //img(src="~assets/avatar-null.svg")
    //img(:src="getChildrenAdded[idx].avatar")
  .nickname {{child.nickname}}
  .tag 儿童
  ghost-btn(:copy="$t('btn.delete')" @clicked="onRemove")


</template>
<script>
import Member from '@/components/wedgits/Member'
import IconAdd from '@/views/Me/IconAdd'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ChildIcon from '@/components/wedgits/ChildIcon'
import DeleteBtn from '@/components/wedgits/DeleteBtn'
import AlipayService from '@/services/AlipayService'
import GhostBtn from '@/components/wedgits/GhostBtn'
export default {
  name: 'AvatarChild',
  components: { GhostBtn, DeleteBtn, ChildIcon, IconAdd, Member },
  props: {
    child: {},
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['fam', 'user']),
  },
  methods: {
    ...mapActions('app', ['RemoveSubUser', 'GetUser']),
    ...mapMutations('app', ['setRouterBack', 'setPending']),
    onAdd() {
      console.log('add child')
      AlipayService.sendEvent(AlipayService.Events.ADD_CHILD_REQUEST)
    },
    onRemove() {
      let payload = {
        userId: this.getMasterId(),
        subUserId: this.child.id,
      }
      //console.log(this.getMasterId())
      this.setPending(true)
      this.RemoveSubUser(payload).then((res) => {
        console.log(res)
        this.GetUser(this.user.id).then((res) => {
          this.setPending(false)
        })
      })
    },

    getMasterId() {
      for (let user of this.user.famUsers) {
        if (user.type === 1) return user.id
      }
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.avatar-child
  width: 100%
  height: 100%
  display: flex
  align-items: center
  justify-content: center
  flex-direction: column
  .copy
    font-size: pxToRem(36)
    color: $cl-blue
  .avatar
    width: pxToRem(180)
    height: pxToRem(180)
  .nickname
    font-size: pxToRem(36)
  .ghost-btn
    margin: pxToRem(60) 0 0 0
  .tag
    font-size: pxToRem(24)
    color: $cl-blue
    background: #e7f1ff
    padding: 0 pxToRem(8)
    margin-top: pxToRem(32)
    margin-bottom: pxToRem(46)
</style>
